import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { EDUCATION_ITEM_LIST_TEXTS } from "../shared/constants";

interface Props {
  open: boolean;
  itemName: string;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteEducationItemDialog: React.FC<Props> = ({
  open,
  itemName,
  isDeleting,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} data-testid="delete-education-item-dialog">
      <DialogTitle>{EDUCATION_ITEM_LIST_TEXTS.deleteConfirmTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {EDUCATION_ITEM_LIST_TEXTS.deleteConfirmMessage(itemName)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isDeleting}>
          {EDUCATION_ITEM_LIST_TEXTS.cancelButton}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" disabled={isDeleting}>
          {EDUCATION_ITEM_LIST_TEXTS.deleteButton}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteEducationItemDialog;
